import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("MMC site error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink px-6 text-center">
          <span className="font-tech text-xs uppercase tracking-[0.3em] text-molten">MMC S.r.l.</span>
          <p className="font-display text-3xl uppercase">Si è verificato un errore</p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="border border-white/25 px-6 py-3 font-tech text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 hover:border-molten hover:text-molten"
          >
            Ricarica la pagina
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
